
$('.OurCustomer-Wrapper .slider-container').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});



$('.customer_reviews_group').slick({
  infinite: false,
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: true,

  prevArrow: `
    <button class="slick-prev slick-arrow" aria-label="Previous slide">
      <svg class="sv-left-arrow" width="25" height="25" viewBox="0 0 25 25" fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path d="M18.6277 24.6735C19.1063 24.2223 19.1241 23.4675 18.6742 22.9913L8.73463 12.4994L18.6741 2.00867C19.1253 1.53246 19.1063 0.778863 18.6277 0.326481C18.1503 -0.125902 17.3967 -0.105687 16.9443 0.371743L6.22976 11.6815C6.01306 11.9101 5.90354 12.2054 5.90354 12.4994C5.90354 12.7934 6.01306 13.0899 6.22976 13.3185L16.9443 24.6283C17.3967 25.1057 18.1503 25.1259 18.6277 24.6735Z"
          fill="#2B2B2B"/>
      </svg>
    </button>
  `,

  nextArrow: `
    <button class="slick-next slick-arrow" aria-label="Next slide">
      <svg class="sv-right-arrow" width="25" height="25" viewBox="0 0 25 25" fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path d="M6.37228 0.326481C5.89366 0.778863 5.87594 1.53246 6.32583 2.00867L16.2654 12.4994L6.32583 22.9913C5.87594 23.4675 5.89366 24.2223 6.37228 24.6735C6.8497 25.1259 7.60329 25.1057 8.05568 24.6283L18.7702 13.3185C18.9869 13.0899 19.0965 12.7934 19.0965 12.4994C19.0965 12.2054 18.9869 11.9101 18.7702 11.6815L8.05568 0.371743C7.60329 -0.105687 6.8497 -0.125902 6.37228 0.326481Z"
          fill="#2B2B2B"/>
      </svg>
    </button>
  `,

  responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});


$(document).ready(function () {

  var slickCheckInterval = setInterval(function () {
    var $slider = $('.flex-controller');
    if (!$slider.length) return;
    if ($slider.children().length === 0) return;
    if ($slider.hasClass('slick-initialized')) {
      clearInterval(slickCheckInterval);
      return;
    }
    $slider.slick({
      infinite: false,
      slidesToShow: 5,
      slidesToScroll: 1,
      arrows: true,

      prevArrow: `
        <button class="slick-prev slick-arrow" aria-label="Previous slide">
          <svg class="sv-left-arrow" width="25" height="25" viewBox="0 0 25 25" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M18.6277 24.6735C19.1063 24.2223 19.1241 23.4675 18.6742 22.9913L8.73463 12.4994L18.6741 2.00867C19.1253 1.53246 19.1063 0.778863 18.6277 0.326481C18.1503 -0.125902 17.3967 -0.105687 16.9443 0.371743L6.22976 11.6815C6.01306 11.9101 5.90354 12.2054 5.90354 12.4994C5.90354 12.7934 6.01306 13.0899 6.22976 13.3185L16.9443 24.6283C17.3967 25.1057 18.1503 25.1259 18.6277 24.6735Z"
              fill="#2B2B2B"/>
          </svg>
        </button>
      `,

      nextArrow: `
        <button class="slick-next slick-arrow" aria-label="Next slide">
          <svg class="sv-right-arrow" width="25" height="25" viewBox="0 0 25 25" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M6.37228 0.326481C5.89366 0.778863 5.87594 1.53246 6.32583 2.00867L16.2654 12.4994L6.32583 22.9913C5.87594 23.4675 5.89366 24.2223 6.37228 24.6735C6.8497 25.1259 7.60329 25.1057 8.05568 24.6283L18.7702 13.3185C18.9869 13.0899 19.0965 12.7934 19.0965 12.4994C19.0965 12.2054 18.9869 11.9101 18.7702 11.6815L8.05568 0.371743C7.60329 -0.105687 6.8497 -0.125902 6.37228 0.326481Z"
              fill="#2B2B2B"/>
          </svg>
        </button>
      `,

      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        }
      ]
    });
    clearInterval(slickCheckInterval);

  }, 300); 
});





(function () {

  function initSlickWhenReady() {
    var $grid = $('product-recommendations.related-products ul.grid.product-grid');

    // Must exist, have items, be visible, and not already initialized
    if (
      $grid.length &&
      $grid.children('li').length > 1 &&
      $grid.is(':visible') &&
      !$grid.hasClass('slick-initialized')
    ) {

      $grid.slick({
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        adaptiveHeight: false,
        swipeToSlide: true,

        prevArrow: `
          <button class="slick-prev slick-arrow" aria-label="Previous slide">
            <svg width="25" height="25" viewBox="0 0 25 25" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path d="M18.6277 24.6735C19.1063 24.2223 19.1241 23.4675 18.6742 22.9913L8.73463 12.4994L18.6741 2.00867C19.1253 1.53246 19.1063 0.778863 18.6277 0.326481C18.1503 -0.125902 17.3967 -0.105687 16.9443 0.371743L6.22976 11.6815C6.01306 11.9101 5.90354 12.2054 5.90354 12.4994C5.90354 12.7934 6.01306 13.0899 6.22976 13.3185L16.9443 24.6283C17.3967 25.1057 18.1503 25.1259 18.6277 24.6735Z"
                fill="#2B2B2B"/>
            </svg>
          </button>
        `,

        nextArrow: `
          <button class="slick-next slick-arrow" aria-label="Next slide">
            <svg width="25" height="25" viewBox="0 0 25 25" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path d="M6.37228 0.326481C5.89366 0.778863 5.87594 1.53246 6.32583 2.00867L16.2654 12.4994L6.32583 22.9913C5.87594 23.4675 5.89366 24.2223 6.37228 24.6735C6.8497 25.1259 7.60329 25.1057 8.05568 24.6283L18.7702 13.3185C18.9869 13.0899 19.0965 12.7934 19.0965 12.4994C19.0965 12.2054 18.9869 11.9101 18.7702 11.6815L8.05568 0.371743C7.60329 -0.105687 6.8497 -0.125902 6.37228 0.326481Z"
                fill="#2B2B2B"/>
            </svg>
          </button>
        `,

        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2
            }
          }
        ]
      });

      /* 🔧 Recalculate after images load (fixes collapsed cards) */
      $grid.find('img').each(function () {
        if (this.complete) return;
        $(this).one('load', function () {
          $grid.slick('setPosition');
        });
      });

      return true;
    }

    return false;
  }

  /* 1️⃣ Try immediately */
  if (initSlickWhenReady()) return;

  /* 2️⃣ Observe DOM changes (Shopify async safe) */
  const observer = new MutationObserver(function () {
    if (initSlickWhenReady()) {
      observer.disconnect();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  /* 3️⃣ Fallback retry (slow mobile / heavy themes) */
  let retries = 0;
  const maxRetries = 20;

  const fallback = setInterval(function () {
    retries++;

    if (initSlickWhenReady() || retries >= maxRetries) {
      clearInterval(fallback);
    }
  }, 500);

})();




$('.RecommendedBridalSets').slick({
  infinite: false,
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: true,

  prevArrow: `
    <button class="slick-prev slick-arrow" aria-label="Previous slide">
      <svg class="sv-left-arrow" width="25" height="25" viewBox="0 0 25 25" fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path d="M18.6277 24.6735C19.1063 24.2223 19.1241 23.4675 18.6742 22.9913L8.73463 12.4994L18.6741 2.00867C19.1253 1.53246 19.1063 0.778863 18.6277 0.326481C18.1503 -0.125902 17.3967 -0.105687 16.9443 0.371743L6.22976 11.6815C6.01306 11.9101 5.90354 12.2054 5.90354 12.4994C5.90354 12.7934 6.01306 13.0899 6.22976 13.3185L16.9443 24.6283C17.3967 25.1057 18.1503 25.1259 18.6277 24.6735Z"
          fill="#2B2B2B"/>
      </svg>
    </button>
  `,

  nextArrow: `
    <button class="slick-next slick-arrow" aria-label="Next slide">
      <svg class="sv-right-arrow" width="25" height="25" viewBox="0 0 25 25" fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path d="M6.37228 0.326481C5.89366 0.778863 5.87594 1.53246 6.32583 2.00867L16.2654 12.4994L6.32583 22.9913C5.87594 23.4675 5.89366 24.2223 6.37228 24.6735C6.8497 25.1259 7.60329 25.1057 8.05568 24.6283L18.7702 13.3185C18.9869 13.0899 19.0965 12.7934 19.0965 12.4994C19.0965 12.2054 18.9869 11.9101 18.7702 11.6815L8.05568 0.371743C7.60329 -0.105687 6.8497 -0.125902 6.37228 0.326481Z"
          fill="#2B2B2B"/>
      </svg>
    </button>
  `,

  responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    }
  ]
});


$('.heading_one').slick({
    infinite: true,
    slidesToShow: 6,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
});


$('.collectioncontain').slick({
  infinite: true,
  slidesToShow: 11,
  slidesToScroll: 1,
  arrows: true,

  prevArrow: `
    <button class="slick-prev slick-arrow" aria-label="Previous slide">
      <svg class="sv-left-arrow" width="25" height="25" viewBox="0 0 25 25" fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path d="M18.6277 24.6735C19.1063 24.2223 19.1241 23.4675 18.6742 22.9913L8.73463 12.4994L18.6741 2.00867C19.1253 1.53246 19.1063 0.778863 18.6277 0.326481C18.1503 -0.125902 17.3967 -0.105687 16.9443 0.371743L6.22976 11.6815C6.01306 11.9101 5.90354 12.2054 5.90354 12.4994C5.90354 12.7934 6.01306 13.0899 6.22976 13.3185L16.9443 24.6283C17.3967 25.1057 18.1503 25.1259 18.6277 24.6735Z"
          fill="#2B2B2B"/>
      </svg>
    </button>
  `,

  nextArrow: `
    <button class="slick-next slick-arrow" aria-label="Next slide">
      <svg class="sv-right-arrow" width="25" height="25" viewBox="0 0 25 25" fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path d="M6.37228 0.326481C5.89366 0.778863 5.87594 1.53246 6.32583 2.00867L16.2654 12.4994L6.32583 22.9913C5.87594 23.4675 5.89366 24.2223 6.37228 24.6735C6.8497 25.1259 7.60329 25.1057 8.05568 24.6283L18.7702 13.3185C18.9869 13.0899 19.0965 12.7934 19.0965 12.4994C19.0965 12.2054 18.9869 11.9101 18.7702 11.6815L8.05568 0.371743C7.60329 -0.105687 6.8497 -0.125902 6.37228 0.326481Z"
          fill="#2B2B2B"/>
      </svg>
    </button>
  `,

  responsive: [
  {
      breakpoint: 1200,
      settings: {
        slidesToShow: 8,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 1000,
      settings: {
        slidesToShow: 6,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    }
  ]
});





$('.ExpandableContent-Content.ProductConfigurableAttributes-ExpandableContentContent .DimaondShape').slick({
    infinite: true,
    slidesToShow: 6,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    }
  ]
});


const slider = document.querySelector('.ullalighnes');
const progressBar = document.querySelector('.scroll-progress-bar');

function updateProgress() {
  if (!slider || !progressBar) return; // extra safety

  const scrollLeft = slider.scrollLeft;
  const maxScroll = slider.scrollWidth - slider.clientWidth;

  const totalItems = slider.children.length;
  let baseProgress = 100 / totalItems;

  const minBase = 20;
  baseProgress = Math.max(baseProgress, minBase);

  let progress = 0;
  if (maxScroll > 0) {
    progress = (scrollLeft / maxScroll) * (100 - baseProgress);
  }

  progressBar.style.width = (baseProgress + progress) + '%';
}

// ✅ proper existence check
if (slider && progressBar) {
  slider.addEventListener('scroll', updateProgress);
  window.addEventListener('load', updateProgress);
  window.addEventListener('resize', updateProgress);
}
